export const E_TIPO_CLIENTE = {
    Armador: '1',
    Carga: '2',
};

export const E_TIPO_TELA = {
    Filtro: '0', 
    Importacao: '1' ,
    Exportacao: '2',
    Cabotagem: '3' ,
    Transbordo: '4' ,
    Remocoes: '5' ,
    ResultadoSimulacao: 'ResultadoSimulacao',
};

export const E_SENTIDO_OPERACAO = {
    Embarque: '1',
    Desembarque: '2',
    Embarque_Desembarque: '3',
    RemocaoBordo: '4',
    RemocaoTerra: '5',
};

export const E_ORIGEM_CARGA = {
    Importada: '1',
    Nacional: '2',
    Importada_Nacional: '3'
};

export const E_STATUS_CNTR = {
    Cheio: '1',
    Vazio: '2',
};

export const E_TIPO = {
    Cntr20: '1',
    Cntr40: '2',
};

export const E_TIPO_CNTR = {
    Dry: '1',
    FlatOpenTop: '2',
    Reefer: '3',
    Tank: '4',
    OOG: '5',
    Bundle: '6',
};

export const E_CG_REF_CODES = {
    TipoCliente: 'CALC_TIPO_CLIENTE',
    SentidoOperacao: 'CALC_SENTIDO_OPERACAO',
    Modalidade: 'CALC_MODALIDADE',
    OrigemCarga: 'CALC_ORIGEM_CARGA',
    StatusCntr: 'CALC_STATUS_CNTR',
    IsoCntr: 'CALC_ISO_CNTR',
    TipoCntr: 'CALC_TIPO_CNTR',
    TipoRegime: 'CALC_TIPO_REGIME',
    TipoDeclaracao: 'CALC_TIPO_DECLARACAO',
    ManualMecanizada: 'CALC_MANUAL_MECANIZADA',
    ParcialTotal: 'CALC_PARCIAL_TOTAL',
    TipoTransbordo: 'CALC_TIPO_TRANSBORDO',
};

export const E_CONDICAO = {
    Sim: 'V',
    Nao: 'F',
    N_a: 'N',
    Zero: 0,
};

export const E_AGRUPADORES = {
    Desova: '1',
    Estufagem: '2',
    RegistroFotografico: '3',
};

export const E_SUB_AGRUPADOR = {
    Manual: '1',
    Mecanizada: '2',
    Total: '3',
    Parcial: '4',
};

export const E_TIPO_REGIME = {
    House: '1',
    Pier: '2',
};

export const E_TIPO_DECLARACAO = {
    DI: '1',
    DTA: '2',
    DSA: '3',
    DTC: '4',
    CRP: '5',
};

export const E_TIPO_CARGA_IMP = {
    OpenTop: '5',
    Oog: '2',
};

export const E_PARCIAL_TOTAL_IMP = {
    Parcial: '1',
    Total: '2',
};

export const E_SERVICO_QTD_DUE = 
{
    CodServico: 3012
};

export const E_TITULO_TELA = {
    Importacao: 'Importação',
    Exportacao: 'Exportação',
    Cabotagem: 'Cabotagem',
    Transbordo: 'Transbordo' ,
    Remocoes: 'Remoções' ,
};


// WEBPACK FOOTER //
// ./src/modules/simulacao-servicos/stores/Enum.js